import Button from 'devextreme-react/button';
import { Template } from 'devextreme-react/core/template';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import React from 'react';
import UserPanel from '../user-panel/UserPanel';
import './Header.scss';
import { useNavigate } from 'react-router-dom';

export default function Header({ menuToggleEnabled, title, toggleMenu }) {
  const navigate = useNavigate();
  return (
    <header className={'header-component'}>
      <Toolbar className={'header-toolbar'}>
        <Item
          visible={menuToggleEnabled}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <Button icon='menu' stylingMode='text' onClick={toggleMenu} />
        </Item>
        <Item
          location={'before'}
          cssClass={'header-title'}
          text={title}
          visible={!!title}
          onClick={(e) => {
            navigate('/home');
          }}
        />
        <Item
          location={'center'}
          cssClass={'header-title'}
          text={'Bejelentkezés terápiára'}
          visible={true}
          locateInMenu='auto'
          onClick={(e) => {
            navigate('/bejelentkezes');
          }}
        />
        <Item
          location={'after'}
          cssClass={'header-title'}
          text={'Alapítványi támogatások'}
          visible={true}
          locateInMenu='auto'
        />
        <Item
          location={'before'}
          locateInMenu={'auto'}
          menuItemTemplate={'userPanelTemplate'}
        >
          <Button
            className={'user-button authorization'}
            width={100}
            height={'100%'}
            stylingMode={'text'}
          >
            <UserPanel menuMode={'context'} />
          </Button>
        </Item>
        <Template name={'userPanelTemplate'}>
          <UserPanel menuMode={'list'} />
        </Template>
      </Toolbar>
    </header>
  );
}
